// extracted by mini-css-extract-plugin
export default {"wrap":"DemoHorizontalCartList2_wrap__fO61Z","upAngle":"DemoHorizontalCartList2_upAngle__Us27U","downAngle":"DemoHorizontalCartList2_downAngle__eC7kY"};